import React, { useState } from 'react';
import {
  FAQContainer,
  FAQTitle,
  FAQAccordion,
  FAQItem,
  FAQQuestionContainer,
  FAQQuestionText,
  FAQToggleIcon,
  FAQAnswer
} from './styles';

const faqData = [
  {
    id: 1,
    question: '¿Qué es FLOQSS?',
    answer: 'FLOQSS es la infraestructura digital que te permite vender contenidos digitales a millones de personas que no usan tarjeta ni confían en compras online. Somos el puente entre tu producto y un nuevo público listo para pagar en efectivo al recibir.'
  },
  {
    id: 2,
    question: '¿Cómo puedo comenzar a usar FLOQSS?',
    answer: 'Solo necesitas registrarte gratis y activar el botón de "Pagar Contraentrega" en tu oferta. Puedes integrar FLOQSS en tu página, redes sociales o marketplace interno.'
  },
  {
    id: 3,
    question: '¿Cuáles son los costos involucrados en la utilización de FLOQSS?',
    answer: 'Solo pagas si vendes. La comisión es del 9,77% + 9.900 COP por venta efectuada. No hay costos fijos ni cobros si el cliente rechaza la entrega. La logística (transporte) es gestionada por FLOQSS pero es un servicio externo, pagado por el vendedor solo si decide enviar.'
  },
  {
    id: 4,
    question: '¿Cómo funciona el proceso de pago y entrega?',
    answer: 'El cliente compra online, pero paga solo cuando recibe el acceso físico en su casa. FLOQSS se encarga de todo: impresión, empaque, despacho y confirmación. Tú acompañas el estado de cada venta desde tu panel.'
  },
  {
    id: 5,
    question: '¿FLOQSS ofrece soporte al cliente?',
    answer: 'Sí. Como vendedor, cuentas con soporte personalizado desde el inicio. Te guiamos paso a paso con entrenamientos gratuitos, sesiones personalizadas y acompañamiento en todo momento para que puedas operar con confianza y vender más desde el primer día. Y para tus clientes, FLOQSS gestiona toda la comunicación automática durante el proceso de entrega, manteniéndolos informados vía WhatsApp y correo electrónico. Esto aumenta la confianza, reduce devoluciones y mejora tu reputación, sin que tengas que hacer nada, sin costos.'
  },
  {
    id: 6,
    question: '¿Cuáles son los beneficios de usar FLOQSS para los consumidores?',
    answer: 'Tu cliente no necesita tarjeta, ni registro complicado, ni confiar en lo desconocido. Compra, recibe en casa y paga en el momento. Simple, seguro y sin fricciones.'
  },
  {
    id: 7,
    question: '¿Cómo funciona la cuestión de los envíos por FLOQSS?',
    answer: 'FLOQSS coordina los envíos automáticamente con las principales transportadoras del país. El costo del flete es asumido por el vendedor y se descuenta directamente de tu cartera FLOQSS solo si decides enviar el producto. Todo queda bajo tu control.'
  },
  {
    id: 8,
    question: '¿Cómo puedo comenzar a usar FLOQSS?',
    answer: 'Solo necesitas registrarte gratis y activar el botón de "Pagar Contraentrega" en tu oferta. Puedes integrar FLOQSS en tu página, redes sociales o marketplace interno.'
  }
];

const FAQSection = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <FAQContainer>
      <FAQTitle>Preguntas Frecuentes</FAQTitle>
      <FAQAccordion>
        {faqData.map((item) => (
          <FAQItem key={item.id}>
            <FAQQuestionContainer onClick={() => toggleItem(item.id)}>
              <FAQQuestionText>{item.question}</FAQQuestionText>
              <FAQToggleIcon isOpen={openItems[item.id]}>
                {openItems[item.id] ? '−' : '+'}
              </FAQToggleIcon>
            </FAQQuestionContainer>
            <FAQAnswer isOpen={openItems[item.id]}>
              {item.answer}
            </FAQAnswer>
          </FAQItem>
        ))}
      </FAQAccordion>
    </FAQContainer>
  );
};

export default FAQSection;